<template>
    <div>
        <h1 style="margin-bottom: -5px; margin-top: -5px">{{ title }}</h1>
        <hr style="margin-bottom: 20px;">
    </div>
</template>

<script>
    export default {
        name: 'CardLayout',
        props: {
            title: {
                type: String,
                isRequired: true
            }
        }
    }
</script>

<style scoped>
    h1 {
        color: rgb(75, 74, 74);
    }
</style>




// WEBPACK FOOTER //
// src/components/LayoutPart/CardHeader.vue